<template>
  <v-container>
    <v-card outlined class="mb-4">
      <v-card-title class="subtitle-1 font-weight-bold">
        <v-icon left color="primary">
          fas fa-camera
        </v-icon>

        Evidencia fotográfica de la grúa
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <div class="caption grey--text text--darken-1 mb-4">
          Adjunte fotografías correspondientes a cada elemento de la revisión.
        </div>

        <v-row>
          <v-col
            v-for="categoria in categorias"
            :key="categoria.ruta"
            cols="12"
            md="6"
            lg="4"
            class="py-2"
          >
            <v-card outlined class="pa-3 fill-height">
              <!-- Título -->
              <div class="d-flex align-center mb-2">
                <v-icon small color="primary" class="mr-2">
                  {{ categoria.icon }}
                </v-icon>

                <span class="subtitle-2 font-weight-bold">
                  {{ categoria.nombre }}
                </span>
              </div>

              <v-divider class="mb-3"></v-divider>

              <!-- Archivos -->
              <v-file-input
                v-model="categoria.archivos"
                multiple
                accept="image/*"
                outlined
                dense
                small-chips
                hide-details
                prepend-icon=""
                prepend-inner-icon="fas fa-camera"
                label="Seleccionar imágenes"
              ></v-file-input>

              <!-- Archivos seleccionados -->
              <div
                v-if="categoria.archivos && categoria.archivos.length"
                class="caption grey--text mt-2"
              >
                {{ categoria.archivos.length }}
                {{
                  categoria.archivos.length === 1
                    ? "imagen seleccionada"
                    : "imágenes seleccionadas"
                }}
              </div>

              <!-- Imágenes ya cargadas -->
              <v-row v-if="categoria.vistas.length" dense class="mt-2">
                <v-col
                  v-for="archivo in categoria.vistas"
                  :key="archivo.id"
                  cols="4"
                >
                  <v-hover v-slot="{ hover }">
                    <v-card
                      outlined
                      class="overflow-hidden"
                      @click="abrirVistaPrevia(archivo)"
                    >
                      <v-img :src="archivo.url" height="90" cover>
                        <template v-slot:default>
                          <v-overlay :value="hover" absolute>
                            <v-icon>
                              fas fa-search-plus
                            </v-icon>
                          </v-overlay>
                        </template>
                      </v-img>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>

              <div
                v-if="categoria.vistas.length"
                class="caption grey--text mt-2"
              >
                {{ categoria.vistas.length }}
                {{
                  categoria.vistas.length === 1
                    ? "imagen cargada"
                    : "imágenes cargadas"
                }}
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="px-4 py-3">
        <div class="caption grey--text">
          Las imágenes se almacenarán por grúa, fecha y categoría.
        </div>

        <v-spacer></v-spacer>

        <v-btn
          color="primary"
          depressed
          :loading="subiendoArchivos"
          :disabled="hayArchivosPendientes"
          @click="subirArchivos"
        >
          <v-icon left v-if="nombreBotonSubirImagenes == 'Subir Imágenes'">
            fas fa-cloud-upload-alt
          </v-icon>
          {{ nombreBotonSubirImagenes }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Vista previa -->
    <v-dialog v-model="dialogPreview" max-width="700">
      <v-card>
        <v-card-title class="subtitle-1">
          Vista previa

          <v-spacer></v-spacer>

          <v-btn icon @click="dialogPreview = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-2">
          <v-img
            v-if="archivoSeleccionado"
            :src="archivoSeleccionado.url"
            max-height="600"
            contain
          ></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      bottom
      right
      :timeout="4000"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import Axios from "axios";

export default {
  name: "ArchivosGrua",

  props: {
    nombreGrua: {
      type: String,
      required: true,
    },
    turnoActivo: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      subiendoArchivos: false,
      rutaBase: "",
      snackbar: false,
      snackbarColor: "primary",
      snackbarText: "",

      dialogPreview: false,
      archivoSeleccionado: null,

      categorias: [
        {
          nombre: "Aceite de motor",
          ruta: "ACEITE_MOTOR",
          icon: "fas fa-oil-can",
          archivos: [],
          vistas: [],
        },
        {
          nombre: "Aceite de caja",
          ruta: "ACEITE_CAJA",
          icon: "fas fa-cogs",
          archivos: [],
          vistas: [],
        },
        {
          nombre: "Coolant de radiador",
          ruta: "COOLANT_RADIADOR",
          icon: "fas fa-temperature-low",
          archivos: [],
          vistas: [],
        },
        {
          nombre: "Niveles de solución",
          ruta: "NIVELES_SOLUCION",
          icon: "fas fa-flask",
          archivos: [],
          vistas: [],
        },
        {
          nombre: "Tablero de marcadores",
          ruta: "TABLERO_MARCADORES",
          icon: "fas fa-tachometer-alt",
          archivos: [],
          vistas: [],
        },
        {
          nombre: "Golpes y rayones",
          ruta: "GOLPES_RAYONES",
          icon: "fas fa-car-crash",
          archivos: [],
          vistas: [],
        },
        {
          nombre: "Gasolina",
          ruta: "GASOLINA",
          icon: "fas fa-gas-pump",
          archivos: [],
          vistas: [],
        },
      ],
    };
  },

  computed: {
    nombreBotonSubirImagenes() {
      if (
        this.turnoActivo &&
        (this.nombreGrua == "REGIONAL FOUR" ||
          this.nombreGrua == "REGIONAL TEN")
      ) {
        return "Finalizar Turno";
      } else if (
        !this.turnoActivo &&
        (this.nombreGrua == "REGIONAL FOUR" ||
          this.nombreGrua == "REGIONAL TEN")
      ) {
        return "Iniciar Turno";
      } else {
        return "Subir Imágenes";
      }
    },
    hayArchivosPendientes() {
      // FOUR y TEN no requieren ninguna imagen
      if (
        this.nombreGrua == "REGIONAL FOUR" ||
        this.nombreGrua == "REGIONAL TEN"
      ) {
        return false;
      }

      const categoriaGasolina = this.categorias.find(
        (categoria) => categoria.ruta === "GASOLINA",
      );

      // TWO y NINE requieren Gasolina + Aceite de caja
      if (
        this.nombreGrua == "REGIONAL TWO" ||
        this.nombreGrua == "REGIONAL NINE"
      ) {
        const categoriaAceiteCaja = this.categorias.find(
          (categoria) => categoria.ruta === "ACEITE_CAJA",
        );

        return (
          !categoriaGasolina ||
          !categoriaGasolina.archivos ||
          categoriaGasolina.archivos.length === 0 ||
          !categoriaAceiteCaja ||
          !categoriaAceiteCaja.archivos ||
          categoriaAceiteCaja.archivos.length === 0
        );
      }

      return (
        !categoriaGasolina ||
        !categoriaGasolina.archivos ||
        categoriaGasolina.archivos.length === 0
      );
    },
  },

  created() {
    this.obtenerArchivos();
  },

  methods: {
    async subirArchivos() {
      if (this.hayArchivosPendientes) {
        this.mostrarMensaje("Debe seleccionar al menos una imagen", "error");

        return;
      }

      // EXCEPCION: ESTAS GRUAS NO REQUIEREN QUE SE SUBAN ARCHIVOS
      if (
        this.nombreGrua == "REGIONAL FOUR" ||
        this.nombreGrua == "REGIONAL TEN"
      ) {
        this.$emit("ruta-base", "N/A");
        return;
      }

      try {
        this.subiendoArchivos = true;

        const formData = new FormData();

        formData.append("IdUsuario", this.$store.state.usuario.idUsuario);
        formData.append("TurnoActivo", this.turnoActivo);

        let requestIndex = 0;

        this.categorias.forEach((categoria) => {
          if (!categoria.archivos || categoria.archivos.length === 0) {
            return;
          }

          /*
           * /GRUAS/{NOMBRE_GRUA}/{DIA_MES_AÑO}/{CATEGORIA}
           */
          const ruta = `${categoria.ruta}`;

          formData.append(`TipoArchivos[${requestIndex}].Ruta`, ruta);

          categoria.archivos.forEach((archivo) => {
            formData.append(`TipoArchivos[${requestIndex}].Archivos`, archivo);
          });

          requestIndex++;
        });

        const response = await Axios.post(
          `/api/OneDrive/Gruas/${this.nombreGrua}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (response.data) {
          this.mostrarMensaje("Imágenes subidas exitosamente", "primary");

          this.categorias.forEach((categoria) => {
            categoria.archivos = [];
          });

          this.rutaBase = response.data.rutaBase;
          this.$emit("ruta-base", this.rutaBase);

          // await this.obtenerArchivos();
        } else {
          this.mostrarMensaje("No fue posible subir las imágenes", "error");
        }
      } catch (error) {
        console.error("Error subiendo imágenes:", error);

        this.mostrarMensaje("Ocurrió un error al subir las imágenes", "error");
      } finally {
        this.subiendoArchivos = false;
      }
    },

    async obtenerArchivos() {
      if (!this.rutaBase) {
        return;
      }
      try {
        for (const categoria of this.categorias) {
          categoria.vistas = [];

          const ruta = `${this.rutaBase}/${categoria.ruta}`;

          const response = await Axios.get(
            "api/OneDrive?ruta=" + encodeURIComponent(ruta),
          );

          if (response.data && response.data.value) {
            const archivos = response.data.value;

            for (const archivo of archivos) {
              try {
                const preview = await Axios.get(
                  `api/OneDrive/VistaPrevia/${archivo.id}`,
                );

                if (
                  preview.data &&
                  !preview.data.error &&
                  preview.data.value &&
                  preview.data.value.length
                ) {
                  categoria.vistas.push({
                    id: archivo.id,
                    nombre: archivo.name,
                    url: preview.data.value[0].large.url,
                  });
                }
              } catch (error) {
                console.error(`Error obteniendo preview ${archivo.id}:`, error);
              }
            }
          }
        }
      } catch (error) {
        console.error("Error obteniendo archivos:", error);
      }
    },

    abrirVistaPrevia(archivo) {
      this.archivoSeleccionado = archivo;
      this.dialogPreview = true;
    },

    mostrarMensaje(texto, color = "primary") {
      this.snackbarText = texto;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
};
</script>
